import React, { Component } from 'react';
import Header from '../../../Containers/Header/Header';
import Footer from '../../../Containers/Footer';
import Loading from "../../../Containers/Loading";

class AdminMain extends Component {
    state = {
        // loading
        isLoadingHide: false
    }

    componentDidMount = () => {
        this.setState({
            isLoadingHide: true
        });
    }


    render() {
        if (!this.state.isLoadingHide) {
            return (<Loading/>);
        }

        return(
          <div className="beaconWrapper">
            <Header selectedIndex={0} />
              <div className="allconWrapper">
                <div className="contentsWrapper">

                  <div className="adminWrapper main">

                  </div>

                </div>
              </div>
            <Footer />
          </div>
        );
    }
}
export default AdminMain;



// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminMain/index.js